import { graphql } from 'react-relay';

const ChargeUpdatedStatus = graphql`
  subscription ChargeUpdatedStatusSubscription(
    $input: ChargeUpdatedStatusInput!
  ) {
    ChargeUpdatedStatus(input: $input) {
      charge {
        id
        status
      }
    }
  }
`;

export default ChargeUpdatedStatus;
